import { styled } from '@horizontal-org/shira-ui'

export const Subtitle = styled.h5`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 25px;
  font-weight: 400;
`
